import { render, staticRenderFns } from "./CourseBuilderHeader.vue?vue&type=template&id=8eb5201c&scoped=true&"
import script from "./CourseBuilderHeader.vue?vue&type=script&lang=js&"
export * from "./CourseBuilderHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eb5201c",
  null
  
)

export default component.exports